import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const fetcher = () =>
  TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.SUSTRACCIONVENTAS).then(({ data }) => data)

const SustraccionVentaSelect = ({ tiposRef, ...props }) => {
  const { data: sustracciones } = useSwr('select_sustraccionVenta', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  React.useEffect(() => {
    if (tiposRef) {
      tiposRef.current = sustracciones
    }
  }, [tiposRef, sustracciones])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {sustracciones.map((val, key) => (
        <option key={key} value={val._id}>
          {`${val.nombre} - (${val.porcentaje} %)`}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(SustraccionVentaSelect)
